import React from "react";
import { API_BASE_URL } from "../config";

export async function generateManifestPdf(manifestJson) {
  // Send manifestJson to backend to generate PDF
  let base = (API_BASE_URL || "").replace(/\/$/, "");
  if (!base && typeof window !== 'undefined') {
    const host = window.location?.host || '';
    if (/^(localhost|127\.0\.0\.1)(:3000)?$/i.test(host)) {
      base = 'http://localhost:3001';
    } else {
      base = window.location?.origin || '';
    }
  }
  const url = `${base.replace(/\/$/, '')}/api/export-manifest-pdf`;
  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(manifestJson),
  });
  if (!response.ok) throw new Error("PDF generation failed");
  const blob = await response.blob();
  // Download the PDF
  const blobUrl = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobUrl;
  // Derive filename pattern: "Lastplan-<Name>-<YYYYMMDD>.pdf" (omit -<Name>- if no name)
  const rawName = manifestJson?._exportVehicleName || manifestJson?.primaryVehicleName || manifestJson?.truck?.name || '';
  let safeName = rawName
    .toString()
    .trim()
    .replace(/[^A-Za-z0-9-_ ]+/g, '')
    .replace(/\s+/g, '-')
    .slice(0, 40);
  if (safeName === '') safeName = '';
  const dateStr = new Date();
  const y = dateStr.getFullYear();
  const m = String(dateStr.getMonth() + 1).padStart(2, '0');
  const d = String(dateStr.getDate()).padStart(2, '0');
  const stamp = `${y}${m}${d}`;
  a.download = safeName ? `Lastplan-${safeName}-${stamp}.pdf` : `Lastplan-${stamp}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(blobUrl);
}
